import React from 'react';
import './App.css';
import ChatButton from "./components/ChatButton";
import MessageBox from "./components/MessageBox"
import NavBar from "./components/NavBar"
import Scroller from "./components/Scroller"
import SideBar from "./components/SideBar"
import { useState } from "react";

interface outputData {
  message_content: string;
  table_content: string;
}

function App() {
  const [inputText,setInputText] = useState('');
  //const [outputData, setOutputData] = useState({});
  const [outputData, setOutputData] = useState<outputData>({
    message_content: '',
    table_content: '',
  });
  return(
    <div className="app-container">
      <div className="left-column">
        <SideBar/>
      </div>
      <div className="right-column">
        <NavBar/>
        <Scroller message_content={outputData.message_content} html_content={outputData.table_content}/>
        <MessageBox inputText={inputText} setInputText={setInputText} outputData={outputData} setOutputData={setOutputData}/>
      </div>

    </div>
  );
}

export default App;
